import axios from "axios";
import { configs } from "../../../assets/Config";

// get order list by order type
export function getSellsOrderList(token, type, page, size) {
    return new Promise(async (resolve, reject) => {
        try {

            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/orders/${type}${page && size ? `?page=${page}&size=${size}` : ""}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get demat account list
export function getDematAccList(token) {
    return new Promise(async (resolve, reject) => {
        try {

            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/loadDematAccount`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// reject sell order 
export function rejectSellOrder(token, orderId, remark) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "order_id": orderId,
                "customer_remark": remark
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/rejectUserOrder`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// edit sell order
export function editSellOrder(token, orderId, quantity, price, deal_done_by_admin_id, esop_holder, allow_user_update, new_user_id, upmark, upmark_final_pay, distributor_id, is_dealer_order, is_stamp_duty_applicable) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "order_id": orderId,
                "quantity": quantity,
                "price_per_share": price
            }
            // ensure single admin id only (no object)
            const adminId = deal_done_by_admin_id != null && typeof deal_done_by_admin_id === 'object' && deal_done_by_admin_id.id != null
                ? deal_done_by_admin_id.id
                : (typeof deal_done_by_admin_id === 'number' || (typeof deal_done_by_admin_id === 'string' && deal_done_by_admin_id !== ''))
                    ? deal_done_by_admin_id
                    : null
            if (adminId != null) {
                data.deal_done_by_admin_id = adminId
            }
            if (esop_holder !== undefined && esop_holder !== null && esop_holder !== "") {
                data.esop_holder = !!esop_holder
            }
            if (allow_user_update !== undefined && allow_user_update !== null && allow_user_update !== "") {
                data.allow_user_update = !!allow_user_update
            }
            if (new_user_id !== undefined && new_user_id !== null && new_user_id !== "") {
                data.new_user_id = new_user_id
            }
            if (upmark !== undefined && upmark !== null && upmark !== "") {
                data.upmark = upmark
            }
            if (upmark_final_pay !== undefined && upmark_final_pay !== null && upmark_final_pay !== "") {
                data.upmark_final_pay = upmark_final_pay
            }
            if (distributor_id !== undefined && distributor_id !== null && distributor_id !== "") {
                data.distributor_id = distributor_id
            }
            if (is_dealer_order !== undefined && is_dealer_order !== null && is_dealer_order !== "") {
                data.is_dealer_order = is_dealer_order ? 1 : 0
            }
            if (is_stamp_duty_applicable !== undefined && is_stamp_duty_applicable !== null && is_stamp_duty_applicable !== "") {
                data.is_stamp_duty_applicable = is_stamp_duty_applicable ? 1 : 0
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/updateGeneratedOrders`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// approve sell order 
export function approveSellOrder(token, orderId, dematId) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "order_id": orderId,
                "demat_id": dematId
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/approveOrder`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// acknowledge sell order 
export function acknowSellOrder(token, orderId, remark, status) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "order_id": orderId,
                "customer_remark": remark,
                "status": status
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/acknowledgeShareTransfer`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// complete sell order 
export function completeSellOrder(token, orderId, remark, dealerUTR) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "order_id": orderId,
                "customer_remark": remark,
                "dealer_transaction_utr_confirmation": dealerUTR
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/completeOrder`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// mark order as dealer delivery pending
export function markDealerDeliveryPending(token, orderId, remark, dealerUTR) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "order_id": orderId,
                "customer_remark": remark,
                "dealer_transaction_utr_confirmation": dealerUTR
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/dealerDeliveryPending`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// confirm sell order share transfer
export function confirmSellOrderShareTransfer(token, orderId, remark) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "order_id": orderId,
                "customer_remark": remark,
                "consent": 1
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/transferShareOnUserBehalf`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// delete order by id
export function deleteSellOrder(token, orderId) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "order_id": orderId
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/deleteOrder`,
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// restore deleted order by id
export function restoreSellOrder(token, orderId) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "order_id": orderId
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/restoreOrder`,
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// download delivery note
export function downloadDeliveryNote(token, orderId) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/downloadDeliveryNote/${orderId}`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// download deal note
export function downloadDealNote(token, orderId) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/download-deal-note/${orderId}`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get HDFC sheet
export function downloadHDFCSheet(token, orderIds) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/HDFCPaymentTransferSheet`,
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                data: {
                    order_ids: orderIds
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get HDFC stamp duty sheet
export function downloadHDFCStampDutySheet(token, orderIds) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/stampDuty/HDFCPaymentTransferSheet`,
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                data: {
                    order_ids: orderIds
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// sell manual order punch by customer id
export function sellManualOrderPunchCustomerId(token, userId, companyId, price, quantity, dealerOrder, distributorId, upmark, upmark_final_pay, deal_done_by_admin_id, esop_holder, allow_user_update, is_stamp_duty_applicable) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "user_id": userId,
                "company_id": companyId,
                "quantity": quantity,
                "price_per_share": price,
                "is_dealer_order": dealerOrder,
                "upmark": upmark,
                "upmark_final_pay": upmark_final_pay,
                "distributor_id": distributorId,
                "deal_done_by_admin_id": deal_done_by_admin_id,
                "esop_holder": !!esop_holder,
                "allow_user_update": allow_user_update ? 1 : 0,
                "is_stamp_duty_applicable": is_stamp_duty_applicable ? 1 : 0
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/manualOrderPunching`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// update sell order comment
export function sellOrderComment(token, orderId, comment) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "order_id": orderId,
                "comment": comment
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/comment`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}


// sell reconcile
export function sellReconcileFile(token, hdfcFile, nsdlFile, cdslFile) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = new FormData();
            data.append("nsdl_file", nsdlFile)
            data.append("cdsl_file", cdslFile)
            data.append("hdfc_file", hdfcFile)
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/automation/upload`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// sell reconcile
export function sellReconcileDepLogs(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/automation/tagged-depository-logs`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// sell reconcile — untagged depository logs
export function sellUntaggedDepositoryLogs(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/automation/untagged-depository-logs`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// sell automation — DDP reconciliation report
export function sellDdpRecons(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/automation/ddp-recons`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get execution logs (sell automation)
export function getExecutionLogs(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/automation/execution-logs`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            };
            let res = await axios(config);
            resolve(res);
        } catch (err) {
            resolve(err?.response);
        }
    });
}

// get execution output file (Excel) by id
export function getExecutionOutputFile(token, id) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/automation/execution-output-file/${id}`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            };
            let res = await axios(config);
            resolve(res);
        } catch (err) {
            resolve(err?.response);
        }
    });
}

// get all orders
export function getAllOrders(token) {
    return new Promise(async (resolve, reject) => {
        try {

            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/sell/allOrders?page=0&size=0`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}